export const progressConstants = {
    // Add and editing progress
    SAVING_PROGRESS_REQUEST: 'SAVING_PROGRESS_REQUEST',
    SAVING_PROGRESS_SUCCESS: 'SAVING_PROGRESS_SUCCESS',
    SAVING_PROGRESS_FAILURE: 'SAVING_PROGRESS_FAILURE',

    // Loading progress
    LOAD_PROGRESS_REQUEST: 'LOAD_PROGRESS_REQUEST',
    LOAD_PROGRESS_SUCCESS: 'LOAD_PROGRESS_SUCCESS',
    LOAD_PROGRESS_FAILURE: 'LOAD_PROGRESS_FAILURE',

    // Delete progress
    DELETE_PROGRESS_REQUEST: 'DELETE_PROGRESS_REQUEST',
    DELETE_PROGRESS_SUCCESS: 'DELETE_PROGRESS_SUCCESS',
    DELETE_PROGRESS_FAILURE: 'DELETE_PROGRESS_FAILURE',
}


// WEBPACK FOOTER //
// ./src/redux/constants/progress.constants.js